<template>
  <main class="main page-inside products-page categories-page">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="products-page-top wrapper">
          <div class="title">STORE</div>
          <router-link to="/cart" class="cart button">
            <div class="left">
              <img src="./../img/cart.svg" class="img" />
              <span class="desc">
                <b>CART</b>
              </span>
            </div>
            <div class="right">
              <span class="desc"
                >({{ $parent.cartContents.length }} items)</span
              >
            </div>
          </router-link>
        </div>
        <div class="products-page-wrapper wrapper">
          <transition name="fade">
            <div class="category-list" v-if="$parent.categories">
              <div
                :class="[
                  'category-list__item desc',
                  { active: item == $parent.activeCategory },
                ]"
                v-for="(item, i) in $parent.categories"
                :key="i"
                @click="goToCategory(item)"
              >
                {{ item.title }}
              </div>
            </div>
          </transition>

          <!-- Packs Section -->
          <transition name="fade">
            <div class="product-list-container" v-if="showPacks">
              <div v-if="packsLoading" class="loading">Loading packs...</div>
              <div v-else-if="packsError" class="error">{{ packsError }}</div>
              <div v-else-if="packs && packs.length > 0" class="packs-list">
                <div
                  class="item pack-item"
                  v-for="pack in packs"
                  :key="pack.id"
                >
                  <PackStoreItem
                    :pack="pack"
                    @addToCart="addPackToCart"
                    :currency="currency"
                  />
                </div>
              </div>
              <div v-else class="error">No packs available.</div>
            </div>
          </transition>

          <!-- Products Section -->
          <transition name="fade">
            <div class="product-list-container" v-if="showProducts">
              <div class="list products" v-if="products">
                <div class="item" v-for="(item, i) in products" :key="i">
                  <ProductCard
                    :item="item"
                    :addToCartChosenItem="addToCartChosenItem"
                    @goToProduct="goToProduct"
                    :currency="currency"
                    @addToCart="addToCart"
                  />
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import ProductCard from "../components/ProductCard.vue";
import PackStoreItem from "../components/pack/PackStoreItem.vue";
import usePacks from "@/composables/usePacks";

export default {
  name: "Categories",
  props: ["addToCartChosenItem", "currency", "activeCategory", "currencyCode"],
  components: {
    ProductCard,
    PackStoreItem,
  },
  data: function () {
    return {
      imgDomain: "",
      products: [],
      packs: [],
      packsLoading: true,
      packsError: null,
      showPacks: false,
      showProducts: true,
      packsModule: usePacks(),
    };
  },
  watch: {
    activeCategory: function (newCategory) {
      if (newCategory) {
        if (newCategory.id === 0 || newCategory.title === "Packs") {
          this.showPacks = true;
          this.showProducts = false;
          this.fetchPacks();
        } else {
          this.showPacks = false;
          this.showProducts = true;
          this.getProducts();
        }
      }
    },
    $route: function (to) {
      if (to.path.includes("/store/packs")) {
        this.showPacks = true;
        this.showProducts = false;
        this.fetchPacks();
      } else if (this.activeCategory && this.activeCategory.id !== 0) {
        this.showPacks = false;
        this.showProducts = true;
        this.getProducts();
      }
    },
    currencyCode: function () {
      if (this.showProducts) {
        this.getProducts();
      }
      if (this.showPacks) {
        this.fetchPacks();
      }
    },
  },
  mounted() {
    this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN;

    if (
      this.$route.path.includes("/store/packs") ||
      (this.activeCategory &&
        (this.activeCategory.id === 0 || this.activeCategory.title === "Packs"))
    ) {
      this.showPacks = true;
      this.showProducts = false;
      this.fetchPacks();
    } else if (this.activeCategory) {
      this.showPacks = false;
      this.showProducts = true;
      this.getProducts();
    }
  },
  methods: {
    goToCategory(item) {
      if (item.id === 0 || item.title === "Packs") {
        this.showPacks = true;
        this.showProducts = false;
        this.fetchPacks();
      } else {
        this.showPacks = false;
        this.showProducts = true;
      }
      this.$emit("chooseCategoty", item);
    },

    fetchPacks() {
      this.packsLoading = true;
      this.packsError = null;

      this.packsModule
        .fetchPacks()
        .then((data) => {
          if (data) {
            this.packs = data;
          } else {
            this.packs = this.packsModule.packs.value;
          }
          this.packsLoading = false;
        })
        .catch((error) => {
          console.error("Error fetching packs:", error);
          this.packsError = error.message || "Failed to load packs";
          this.packsLoading = false;
        });
    },

    getProducts() {
      if (
        !this.activeCategory ||
        !this.activeCategory.id ||
        this.activeCategory.id === 0
      )
        return;

      this.$http
        .get(
          process.env.VUE_APP_API +
            "products/?category_id=" +
            this.activeCategory.id
        )
        .then((res) => {
          this.products = res.data.payload;
        })
        .catch((error) => {
          console.error("Error fetching products:", error);
        });
    },

    goToProduct(item) {
      this.$emit("goToProduct", item);
    },

    addToCart(item, id) {
      this.$emit("addToCart", item, id);
    },

    addPackToCart(pack, id, quantity) {
      this.$emit(
        "addToCart",
        {
          ...pack,
          quantity: quantity || 1,
        },
        id,
        quantity || 1,
        "pack"
      );
    },
  },
};
</script>

<style scoped>
.packs-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, 190px);
  justify-content: space-between;
  gap: 20px;
  width: 100%;
}

.loading,
.error {
  width: 100%;
  padding: 20px;
  text-align: center;
}

.error {
  color: #da1e01;
}

@media (max-width: 768px) {
  .packs-list {
    margin-top: 24px;
  }
}

@media (max-width: 460px) {
  .packs-list {
    grid-template-columns: 1fr;
  }
}
</style>
